import store from '../store/store';

const PROD_URL =
    'https://3s6evbdsr2.execute-api.us-east-1.amazonaws.com/prod/log';

const STAGE_URL =
    'https://odnhc85s2f.execute-api.us-east-1.amazonaws.com/dev/log';

declare const __PROD_API__: boolean;

const LAMBDA_URL = __PROD_API__ ? PROD_URL : STAGE_URL;

let clientId = null;
let userId = null;
let email = null;

store.subscribe(state => {
    clientId = state.user.selectedClientId;
    userId = state.user.id;
    email = state.user.email;
});

const logAuthEvents = async ({
    type,
    payload = '',
    response = '',
}: {
    type: string;
    payload?: any;
    response?: string;
}) => {
    if (!type)
        throw new Error('[LogAuthevents]: The argument `type` is required.');

    // Logging is best-effort: a failed request must never break the auth flow.
    try {
        return await fetch(LAMBDA_URL, {
            method: 'POST',
            body: JSON.stringify({
                type,
                payload,
                response,
                clientId,
                userId,
                email,
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
    } catch (error) {
        console.warn('[LogAuthEvents]: Failed to log auth event.', error);
        return null;
    }
};

export default logAuthEvents;
